export default "__VITE_ASSET__CX3Hz1$S__"